module.exports = __webpack_public_path__ + "img/iconLiShiCheLiangDaoZha.61a84293.svg";